import {
  WeatherMapPlaybackButton,
  WeatherMapPlaybackSpeedControl,
} from '../../../../../../components/WeatherMapPlayback/WeatherMapPlayback.jsx';
import { useId } from 'react';
import { Form, Stack } from 'react-bootstrap';
import { DOPPLER_PLAYBACK_SPEED_OPTIONS } from '../../../../config/dopplerRadar.config.js';
import {
  formatDopplerFrameTime,
  getDopplerScrubberLabelPosition,
} from '../../../../utils/dopplerDisplay.utils.js';

const DOPPLER_CONTROLS_WIDTH = 'min(320px, calc(100vw - 2rem))';

export default function DopplerPlaybackControls({
  compact = false,
  frames,
  displayedFrameIndex,
  isPlaying,
  isPlaybackReady,
  playbackSpeed,
  onTogglePlayback,
  onSpeedChange,
  onScrub,
}) {
  const rangeId = useId();

  if (!frames.length) {
    return null;
  }

  const activeFrame = frames[displayedFrameIndex];
  const scrubberLabelPosition = getDopplerScrubberLabelPosition(displayedFrameIndex, frames.length);
  const activeFrameLabel = formatDopplerFrameTime(activeFrame);

  return (
    <div
      className="doppler-playback-controls leaflet-bar bg-white rounded-3 px-2 py-1"
      style={{
        width: compact ? DOPPLER_CONTROLS_WIDTH : 'min(320px, calc(100vw - 5rem))',
      }}
    >
      <Stack gap={2}>
        <div className="d-flex align-items-start gap-1">
          <WeatherMapPlaybackButton
            isPlaying={isPlaying}
            onToggle={onTogglePlayback}
            disabled={!isPlaybackReady}
            playLabel="Play Doppler animation"
            pauseLabel="Pause Doppler animation"
          />

          <WeatherMapPlaybackSpeedControl
            speeds={DOPPLER_PLAYBACK_SPEED_OPTIONS}
            value={playbackSpeed}
            onChange={onSpeedChange}
            disabled={!isPlaybackReady}
            ariaLabel="Doppler animation speed"
            className="flex-nowrap overflow-auto"
            buttonClassName="doppler-playback-speed px-0 py-1"
          />
        </div>

        <div>
          <Form.Label htmlFor={rangeId} className="doppler-playback-label small text-muted mb-0">
            {isPlaybackReady ? 'Radar timeline' : 'Loading radar frames'}
          </Form.Label>
          <div className="position-relative pt-4">
            <div
              className="doppler-scrubber-time position-absolute top-0 small fw-semibold text-white bg-primary rounded-pill px-1 py-1 shadow-sm"
              style={scrubberLabelPosition}
              aria-live="polite"
            >
              {activeFrameLabel}
            </div>
            <Form.Range
              id={rangeId}
              min={0}
              max={frames.length - 1}
              step={1}
              value={displayedFrameIndex}
              onChange={(event) => onScrub(Number(event.target.value))}
              disabled={!isPlaybackReady}
              aria-label="Scrub Doppler radar timeline"
              aria-valuetext={activeFrameLabel}
            />
          </div>
        </div>
      </Stack>
    </div>
  );
}
